import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/constants";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0B2545]/85 border-b border-[#C8A24A]/20"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-24 flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => handleNav("home")}
          className="flex items-center gap-3 group"
        >
          <img
            src={BRAND.logo}
            alt="Sardaar Stevedoring"
            className="h-16 w-16 md:h-20 md:w-20 object-contain bg-white p-1.5 shadow-md"
          />
          <div className="hidden sm:flex flex-col text-left leading-tight">
            <span className="font-serif text-white text-lg tracking-wide">
              SARDAAR
            </span>
            <span className="font-sans text-[#C8A24A] text-[10px] tracking-widest-2 uppercase">
              Stevedoring · Pvt. Ltd.
            </span>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => handleNav(l.id)}
              className="font-sans text-sm tracking-wide text-white/85 hover:text-[#C8A24A] transition-colors duration-300 relative group"
            >
              {l.label}
              <span className="absolute left-0 -bottom-1 w-0 h-px bg-[#C8A24A] group-hover:w-full transition-all duration-500" />
            </button>
          ))}
        </nav>

        <button
          data-testid="header-cta"
          onClick={() => handleNav("contact")}
          className="hidden lg:inline-flex items-center gap-2 bg-[#C8A24A] text-[#0B2545] font-bold px-6 py-3 uppercase text-xs tracking-widest-2 hover:bg-[#D4AF37] transition-colors"
        >
          Request a Quote
        </button>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#061426] border-t border-[#C8A24A]/20"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}`}
                onClick={() => handleNav(l.id)}
                className="font-sans text-left text-white/85 hover:text-[#C8A24A] py-2 border-b border-[#C8A24A]/10"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-header-cta"
              onClick={() => handleNav("contact")}
              className="mt-2 bg-[#C8A24A] text-[#0B2545] font-bold px-6 py-3 uppercase text-xs tracking-widest-2"
            >
              Request a Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
